import { defineStore } from 'pinia'

export const useMenuStore = defineStore('menu', {
    state: () => ({
        isOverlayOpen: false,
        isCoverTranparent: false,
        activeMenu: '',
        returnFocusTarget: null,
    }),
    getters: {},
    actions: {
        setActiveMenu(menu) {
            if (menu === this.activeMenu) {
                this.closeMenu()
                return
            }

            this.activeMenu = menu
            this.isOverlayOpen = true
            this.isCoverTranparent = false
            this.returnFocusTarget = document.activeElement
        },
        setActiveMenuNoOverlay(menu) {
            if (menu === this.activeMenu) {
                this.closeMenu()
                return
            }

            this.activeMenu = menu
            this.isOverlayOpen = true
            this.isCoverTranparent = true
            this.returnFocusTarget = document.activeElement
        },
        closeMenu() {
            this.activeMenu = ''
            this.isOverlayOpen = false
            setTimeout(() => {
                this.returnFocusTarget?.focus()
                this.returnFocusTarget = null
            }, 50)
        },
    },
})
